module.exports = __webpack_public_path__ + "img/green_033.931b064b.png";